<template>
  <div>
    <!--Header Components-->
    <base-header class="pb-6" type="">
      <b-row class="align-items-center py-4">
        <b-col lg="12" cols="12">
          <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <div>
        <loading :active.sync="loading" color='#007bff' :width='128' :height='128' loader='dots' :can-cancel="true"
          :is-full-page="fullPage">
        </loading>
      </div>
      <b-row>
        <b-col lg="12">
          <div class="card-wrapper">
            <card>
              <div slot="header" class="mb-0" v-if="0">
                <b-row>
                  <b-col cols="12">
                    <h3>{{language_terms['QUICK_SEARCH']}}</h3>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col md="3">
                  <label class="form-control-label">{{language_terms["CUSTOMER"]+' From'}}</label>
                  <multiselect :internalSearch="false" v-model="customer_from" id="ajax" label="name" track-by="id"
                    placeholder="Type to search" open-direction="bottom" :options="customers" :multiple="false"
                    :searchable="true" :clear-on-select="false" :close-on-select="true" :options-limit="300" :limit="50"
                    :max-height="600" :show-no-results="false" :hide-selected="false" @search-change="asyncFindCustomer"
                   >
                  </multiselect>
                </b-col>
                <b-col md="3">
                  <label class="form-control-label">{{language_terms["CUSTOMER"] + ' To'}}</label>
                  <multiselect :internalSearch="false" v-model="customer_to" id="ajax" label="name" track-by="id"
                    placeholder="Type to search" open-direction="bottom" :options="customers" :multiple="false"
                    :searchable="true" :clear-on-select="false" :close-on-select="true" :options-limit="300" :limit="50"
                    :max-height="600" :show-no-results="false" :hide-selected="false" @search-change="asyncFindCustomer"
                    >
                  </multiselect>
                </b-col>
                <b-col md="2">
                  <base-input :label="language_terms['DATE']">
                    <flat-picker slot-scope="{focus, blur}" @on-open="focus" @on-close="blur"
                      style="background-color: white;" class="form-control datepicker" v-model="as_of_date">
                    </flat-picker>
                  </base-input>
                </b-col>
                <b-col cols="2">
                  <base-input :label="language_terms['OPTIONS']">
                    <b-form-select v-model="reportOption" :options="reportOptions"></b-form-select>
                  </base-input>
                </b-col>
                <b-col cols="2" class="mt-4">
                    <base-button type="primary" @click="clickOnGenerate" class="mt-2" >
                      {{language_terms['RUN']}}</base-button>
                </b-col>

              </b-row>
            </card>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>

<script>
import moment from 'moment'
import { Select, Option, Table, TableColumn, Dropdown, DropdownMenu, DropdownItem } from "element-ui";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";

export default {
  components: {
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    PaginatedTables
  },
  computed: {
    ...mapState({
      sales_filter: state => state.sales.filter,
      sales_quotations: state => state.sales.sales_quotations,
      sales_orders: state => state.sales.sales_orders,
      sales_invoices: state => state.sales.sales_invoices,
      dos: state => state.dos.dos,
      language_terms: state => state.languages.language_terms,
      selected_lang: state => state.languages.selected_langauge,

    }),
  },
  watch: {
    language_terms: {
      handler(val) {
        this.updateTableLang()
      }
    },
    sales_quotations: {
      // This will let Vue know to look inside the array
      deep: true,
      handler() {
        this.items = this.sales_quotations
      }
    },
    sales_invoices: {
      // This will let Vue know to look inside the array
      deep: true,
      handler() {
        this.items = this.sales_invoices
      }
    },
    sales_orders: {
      // This will let Vue know to look inside the array
      deep: true,
      handler() {
        this.items = this.sales_orders
      }
    },
    dos: {
      // This will let Vue know to look inside the array
      deep: true,
      handler() {
        this.items = this.dos
      }
    }
  },
  async mounted() {
    //default will be last day of past month
    this.as_of_date = moment().date(0).format("YYYY-MM-DD");
  },
  data() {
    return {
      reportOption: 0,
      reportOptions: [
          { value: 0, text: 'No Credit Info' },
          { value: 1, text: 'Include Credit Info' },
          // { value: 'b', text: 'Selected Option' },
          // { value: { C: '3PO' }, text: 'This is an option with object value' },
          // { value: 'd', text: 'This one is disabled', disabled: true }
        ],
      customers: [], // the selections
      customer_from: null,
      customer_to:null,
      as_of_date:null,
      fullPage: true,
      loading: false,
      items: [],
    }
  },

  methods: {
    async asyncFindCustomer(query) {
      let pv = { value: query };
      await axios.post(apiRoutes["CUSTOMER_LOOKUP"], pv, authHeader()).then((response) => {
        if (response.data.code == 1) {
          this.customers = response.data.data;
        } else {
          this.customers = [];
        }

        this.loadingCounter--;
      })
        .catch((error) => {
          if (error.response) {
            Vue.notify({
              group: "notify",
              type: "error",
              text: error.response.data.msg,
              max: 5,
              duration: 5000,
              speed: 300,
            });
          } else {
            console.log("Network error", error);
          }
        });
    },
    async clickOnGenerate() {
      const customer_from_name = (this.customer_from.name.substring(0,this.customer_from.name.indexOf('(')).trim());
      const customer_to_name = (this.customer_to.name.substring(0,this.customer_to.name.indexOf('(')).trim());
      const reportOption = this.reportOption

      let url = 'https://reports.unityerp.com/esteam/debtors-outstanding/' + localStorage.getItem('access_token') + '/' + customer_from_name + '/' + customer_to_name + '/' + this.as_of_date + '/' + reportOption;
      window.open(url);
    }
  }
}
</script>
